import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75dccd8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-list" }
const _hoisted_2 = { class: "news-list-line" }
const _hoisted_3 = {
  class: "infinite-list",
  style: {"overflow":"hidden"}
}
const _hoisted_4 = { class: "news-list-item-lt" }
const _hoisted_5 = { class: "news-list-item-rt" }
const _hoisted_6 = { class: "news-list-item-title" }
const _hoisted_7 = { class: "news-list-item-time" }
const _hoisted_8 = { class: "news-list-item-des" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "load-more" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue';
import type { UploadFile } from 'element-plus/es/components/upload/src/upload.type';
import { useRouter } from 'vue-router'
import Bottom from '../components/bottom.vue'

interface ActivityTag {
  id: string;
  name: string;
  type: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);
const all: ActivityTag = {
  id: "all",
  name: "全部",
  type: 7
}
const activeName = ref("全部")

const handleClick = (tab: any, event: Event) => {
  console.log(tab, event)
  const activityTagId = bindData.activityTagList[tab.index].id;
  if (activityTagId != "all") {
    bindData.newsPageParams.filtrate.activityTagId = activityTagId;
  }
  else {
    bindData.newsPageParams.filtrate.activityTagId = '';
  }
  searchEvent(false);

}
const handleToDetail = (item: any) => {
  router.push('/frontDesk/newsList/newsDetail/' + item.id)
}

const activityTagList: ActivityTag[] = []


const bindData = reactive({
  activityTagList: activityTagList,
  newsPageParams: {
    curPage: 1,
    pageSize: 5,
    filtrate: {
      type: 1,
      activityTagId: "",
      keyword: "",
    },
  },
  newsPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },

});

store.dispatch("frontNewsModule/listActivityTag", { type: 7 }).then(
  (data) => {
    //成功
    bindData.activityTagList = data.result;
    bindData.activityTagList.unshift(all);
    activeName.value = "全部";
  },
  (error) => {
    console.log(error.msg);
  }
);

const remainCount = ref(0)

const searchEvent = (isAppend: boolean) => {
  loading.value = true;
  store
    .dispatch(
      "frontNewsModule/pageInformationList",
      bindData.newsPageParams
    )
    .then(
      (data) => {
        //成功
        if (isAppend) {
          data.result = bindData.newsPageResult.result.concat(data.result);
        }
        bindData.newsPageResult = data;
        remainCount.value = data.totalCount - bindData.newsPageResult.result.length;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent(false);

const loadPageDataEvent = () => {
  if (bindData.newsPageParams.curPage * bindData.newsPageParams.pageSize < bindData.newsPageResult.totalCount) {
    bindData.newsPageParams.curPage = bindData.newsPageParams.curPage + 1;
    searchEvent(true);
  }
};

activeName.value = "全部";


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityTagList, (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.id,
              label: item.name,
              name: item.name
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).newsPageResult.result, (item) => {
                      return _withDirectives((_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "infinite-list-item"
                      }, [
                        _createVNode(_component_el_container, {
                          class: "news-list-item",
                          onClick: () => handleToDetail(item)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_carousel, { height: "300px" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imageList, (image) => {
                                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                      key: image.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_image, {
                                          class: "news-list-item-lt-banner",
                                          src: image.thumbnailUrl
                                        }, null, 8, ["src"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(item.pushTime), 1),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                  innerHTML: item.summary
                                }, null, 8, _hoisted_9)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])), [
                        [_directive_loading, loading.value]
                      ])
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_unref(bindData).newsPageResult.result.length < _unref(bindData).newsPageResult.totalCount)
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 0,
                          class: "load-more-button",
                          type: "text",
                          size: "large",
                          onClick: loadPageDataEvent
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 加载更多..." + _toDisplayString(remainCount.value), 1),
                            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowDownBold)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})